import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("uc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("uc_token")) {
      localStorage.removeItem("uc_token");
      if (window.location.pathname !== "/sprava-9k4x") {
        window.location.href = "/sprava-9k4x";
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(err, fallback = "Něco se pokazilo. Zkuste to prosím znovu.") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d?.msg || err?.message || fallback;
}

export default client;
